import React from 'react';
import POSApplication from '../../components/pos2/POSApplication';
import { POSContextWrapper } from '../../components/pos2/POSContext';
import { Clean } from '../../layouts';

import '../../pos.scss';

const POS = () => (
  <POSContextWrapper>
    <Clean>
      <POSApplication />
    </Clean>
  </POSContextWrapper>
);

export default POS;
